import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import TranslationProvider from './TranslationProvider.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <TranslationProvider>
      <App />
    </TranslationProvider>
  </React.StrictMode>,
)
